export default "__VITE_ASSET__DgG4s8I3__"